// extracted by mini-css-extract-plugin
export var cancelButton = "_os-5";
export var content = "_os-3";
export var createButton = "_os-6";
export var drawerContainer = "_os-0";
export var footer = "_os-2";
export var header = "_os-1";
export var orderFormColumn = "_os-4";